import { Injectable } from '@angular/core';

import { Observable, Observer } from 'rxjs';

import { HttpService } from '../../services/http.service';

@Injectable({ providedIn: 'root' })
export class PdfCreateService {
  constructor(private httpService: HttpService) {}

  public createPdf(file: File): Observable<any> {
    let observer;
    return Observable.create((o: Observer<string>) => {
      observer = o;
      this.createPdfRequest(file).subscribe(
        (response) => {
          if (!response) {
            observer.error('Empty response');
          }

          if (response && response.status === 202) {
            let id = response.text();
            this.checkTaskStatus(id).subscribe(
              (r) => {
                this.wrapByDeleteTask(id, () => {
                  observer.next(id);
                  observer.complete();
                });
              },
              (e) => {
                this.wrapByDeleteTask(id, () => {
                  observer.error(e);
                });
              },
            );
          } else {
            let id = response;
            observer.next(id);
            observer.complete();
          }
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  private wrapByDeleteTask(id, callback) {
    this.createPdfDeleteRequest(id).subscribe(
      (response) => {
        callback();
      },
      (error) => {
        callback();
      },
    );
  }

  private checkTaskStatus(statusId: string): Observable<any> {
    let observer;
    let observable = Observable.create((o: Observer<string>) => {
      observer = o;
      this.checkTaskStatusImpl(statusId, observer);
    });

    return observable;
  }

  private checkTaskStatusImpl(statusId: string, observer: Observer<any>) {
    setTimeout(() => {
      this.createPdfCheckStatusRequest(statusId).subscribe(
        (response) => {
          if (!response) observer.error('Empty response');

          switch (response.state) {
            case 0: //Succeeded
              observer.next(statusId);
              observer.complete();
              break;
            case 1: //Failed
            case 2: //Cancelled
              observer.error(response);
              break;
            case -3: //Not started
            case -2: //Pending
            case -1: //Running
              this.checkTaskStatusImpl(statusId, observer);
              break;
          }
        },
        (error) => {
          observer.error(error);
        },
      );
    }, 500);
  }

  private createPdfRequest(file: File): Observable<any> {
    return this.httpService.putFormData('api/v1/pdf/create', file);
  }

  private createPdfCheckStatusRequest(statusId: string): Observable<any> {
    return this.httpService.getData(`api/v1/pdf/create/${statusId}`);
  }

  private createPdfDeleteRequest(statusId: string): Observable<any> {
    return this.httpService.deleteData(`api/v1/pdf/create/${statusId}`);
  }
}
